<template>
    <div class="login-page">
        <div class="login-title">
            <div class="logo"></div>
<!--            <h3 class="login-title">관리자 로그인</h3>-->
        </div>
        <login-component></login-component>
    </div>
</template>

<script>
    import LoginComponent from "@/components/auth/LoginComponent";
    import EventBus from "@/utils/event-bus";

    export default {
        name: "Login",
        mixins: [],
        components: {LoginComponent},
        provide() {
            return {}
        },
        props: {},
        data() {
            return {}
        },
        created() {},
        mounted() {},
        beforeDestroy() {},
        destroyed() {},
        computed: {
        },
        methods: {},
        watch: {},
    }
</script>
